module.exports = __webpack_public_path__ + "img/mini-logo-grexy.17fbef23.svg";